import { useMutation } from '@tanstack/react-query';
import { useAtom } from 'jotai';

import { post } from 'api/utils';
import ENDPOINTS from 'api/utils/endpoints';
import { useSelectedDealerId } from '@lotlinx-aws/dealer-selector';
import {
  fetchGeoConfigProps,
  PostGeoConfig,
} from 'pages/Settings/GeoConfigSettings/api/useGeoConfig/useGeoConfig';
import { userAtom } from 'store';
import { assertIsDefined } from 'util/assert';

interface postGeoConfigProps extends fetchGeoConfigProps {
  geoConfig?: PostGeoConfig;
}

/**
 * useSaveGeoConfig
 */
async function postGeoConfig({ token, dealerId, geoConfig }: postGeoConfigProps) {
  assertIsDefined(token);
  assertIsDefined(dealerId);
  assertIsDefined(geoConfig);

  return await post<PostGeoConfig>(`${ENDPOINTS.geoConfigSettings}/${dealerId}`, {
    headers: { token },
    body: { ...geoConfig },
  });
}

export default function useSaveGeoConfig() {
  const [dealerId] = useSelectedDealerId();
  const [user] = useAtom(userAtom);
  return useMutation({
    mutationFn: (geoConfig?: PostGeoConfig) =>
      postGeoConfig({ token: user?.token, dealerId, geoConfig }),
  });
}
